<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="syncLog" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "sync-log-view-logs",

  components: { LogListTable },

  props: ["syncLog"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
